<template lang="pug">
  .details-table-cols
    address-col-inline(
      v-for="({title, data, rootPath},i) in items", :title="title" :address="data" :root="rootPath" :key="i")
</template>
<script>
import AddressColInline from './AddressColInline'

export default {
  components: { AddressColInline, },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../../assets/styles/variables.styl"

  .details-table-cols
    display flex
    font-size 95%
    flex-flow wrap

  @media (max-width: $tablet)
    .details-table-cols
      font-size 90%
      flex-direction column
</style>



// WEBPACK FOOTER //
// src/components/record-details/address/AddressCols.vue